var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import axios from 'axios';
import { http } from 'frontend/src/api/client';
import { Box, Table, TableBody, } from "@material-ui/core";
import { ReorderPlaylistsTable } from "./reorder-playlists-table";
// import { usePlaylists } from "frontend/src/domain/playlists";
// import { PlaylistPreview } from "frontend/src/shared/types/playlist";
import move from "frontend/src/lib/move";
import { TableRowsSkeleton } from "frontend/src/ui/table-skeleton";
import { PlaylistsTableRow } from "./playlists-table-row";
import { usePlaylists } from "frontend/src/domain/playlists";
var Playlists = React.memo(function (_a) {
    var playlists = _a.playlists;
    return (React.createElement(React.Fragment, null, playlists.map(function (_a) {
        var id = _a.id, title = _a.title, formatted = _a.duration.formatted, createdAt = _a.createdAt, updatedAt = _a.updatedAt, isPublished = _a.isPublished, trackCount = _a.trackCount, playlist = __rest(_a, ["id", "title", "duration", "createdAt", "updatedAt", "isPublished", "trackCount"]);
        return (React.createElement(PlaylistsTableRow, { key: id, id: id, title: title, trackCount: trackCount, duration: formatted, isPublished: isPublished, type: playlist.type, createdAt: createdAt, updatedAt: updatedAt, client: playlist.type === "private" ? playlist.client : "" }));
    })));
});
export var PlaylistsSearchResultTable = function (_a) {
    var _b;
    var params = _a.params;
    // const { page, rowsPerPage, skip, onChangeRowsPerPage, onChangePage } =
    //   usePagination({ page: 0, rowsPerPage: 25, pageResetDeps: [params] });
    var data = usePlaylists(__assign(__assign({}, params), { skip: 0, take: 9999 })).data;
    var playlists = (_b = data === null || data === void 0 ? void 0 : data.items) !== null && _b !== void 0 ? _b : [];
    var playlistEntries = playlists.map(function (pl) { return ({ id: "pl-" + pl.id, playlist: pl }); });
    var canReorder = (params.type == 'public' && params.title.length == 0);
    var _c = React.useState(playlistEntries), entries = _c[0], setEntries = _c[1];
    if (playlistEntries.length != entries.length) {
        setEntries(playlistEntries);
    }
    var onPlaylistMove = React.useCallback(function (from, to) {
        var reorderedEntries = move(entries, from, to);
        var updatePlaylistOrderRequest = reorderedEntries
            .filter(function (ent) { return ent.playlist.type === 'public'; })
            .map(function (ent, idx) { return ({ id: ent.playlist.id, order: idx }); });
        if (updatePlaylistOrderRequest.length > 0) {
            axios.put('/api/v2/playlists', {
                playlists: updatePlaylistOrderRequest
            }).then(function (res) {
                if (res.status != 200) {
                    alert(res.data.message);
                }
            }).catch(function (err) {
                if (err.response) {
                    alert(err.response.data.message);
                }
            });
            setEntries(reorderedEntries);
        }
    }, [entries, setEntries]);
    var onPlaylistRemove = React.useCallback(function (id) {
        if (!confirm("\u0422\u043E\u0447\u043D\u043E \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u043F\u043B\u0435\u0439\u043B\u0438\u0441\u0442 \u2116" + id + "?")) {
            return;
        }
        http.api.delete("/playlists/" + id)
            .then(function () {
            alert("Плейлист удалён");
        });
        var newEntries = entries.filter(function (entry) { return entry.playlist.id != id; });
        setEntries(newEntries);
    }, [entries, setEntries]);
    return (React.createElement(Box, null, data
        ? (React.createElement(ReorderPlaylistsTable, { canReorder: canReorder, entries: entries, onPlaylistMove: onPlaylistMove, onPlaylistRemove: onPlaylistRemove }))
        : (React.createElement(Table, null,
            React.createElement(TableBody, null,
                React.createElement(TableRowsSkeleton, { rows: 20, columns: 8 }))))));
};
